// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signin-modal{display:flex;flex-direction:column;align-items:center}.signin-modal .signup-link{text-decoration:underline;display:inline;color:inherit}", ""]);
// Exports
module.exports = exports;
